// extracted by mini-css-extract-plugin
export default {"thead":"table-styles_thead__yijQW","theadExternal":"table-styles_theadExternal__UPHaK","th":"table-styles_th__CZTcP"};